import { ISequencePlay, Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { TimelineMax } from "gsap";
import { Texture } from "pixi.js";

export class MultSequence extends Sequence{

    private loaded_textures:Texture[][] = [];

    constructor(_paths:string[]){
        super({textures:[]});
        _paths.forEach(element => this.loaded_textures.push(GameResources.getTextures(element)));
        this.setTexture(this.loaded_textures[0]);
    }

    public setLvl(lvl:number):void{
        this.setTexture(this.loaded_textures[lvl]);
    }

    public play(conf?:ISequencePlay, lvl?:number):TimelineMax{
        if(lvl != undefined) this.setTexture(this.loaded_textures[lvl]);
        return super.playAnimation(conf);
    }
}